import request from '../request';

/** 定位门店 */
export async function getShopInfo() {
  return request<API.CommonResponse<API.ShopInfoVO>>({
    url: '/api/mall/rest/common/locate/shop',
    method: 'POST',
    data: {},
    headers: { isLogin: true },
  });
}

/** 获取省市区全量数据 */
export async function getAreas() {
  return request<API.CommonResponse<API.Region[]>>({
    url: '/api/mall/rest/common/administrativeregion/all',
    method: 'POST',
  });
}

/** 定位行政区域 */
export async function getShipRegion() {
  return request<API.CommonResponse<API.SaleRegion>>({
    url: '/api/mall/rest/common/administrativeregion/locate',
    method: 'POST',
  });
}
